import React from 'react'
import { Container, ContainerInterno, TituloPrincipal, BoxBaixo, BoxBaixoCol6, ImagemPrincipal, ListaConteudos, ListaConteudosItem, ListaConteudosItemBoxTitulo, ListaConteudosItemTitulo, ListaConteudosItemImg, ListaConteudosItemListaBonus, ListaConteudosItemListaBonusItem, BoxDataFim, BoxDataFimSpan } from './Styled'
import bonusCoaching from 'images/renovacao-antecipada-2026/bonus-coaching.png'
import icMelhorOferta from 'images/renovacao-antecipada-2026/ic-melhor-oferta-card.png'
import { date } from '../../../../utils/formatters'

export default function BonusExclusivos ({ planos, dataFim }) {

	const itenCard = (item, premium = false, indexPlano = 0) => {

		console.log(item);

		const mesesAcesso = parseInt(item.assinatura_meses) + parseInt(item.boleto.bonus);

		return <ListaConteudosItem premium={premium} indexPlano={indexPlano}>

			<ListaConteudosItemBoxTitulo>
				<ListaConteudosItemTitulo className={ indexPlano === 1 ? 'ultimo' : '' } premium={premium}>{item.nome.split(" - ")[0].replace("Assinatura ", "")}</ListaConteudosItemTitulo>
				{ indexPlano === 1 ? <ListaConteudosItemImg src={icMelhorOferta} /> : null }
			</ListaConteudosItemBoxTitulo>

			{/* Lista Bonus */}
			<ListaConteudosItemListaBonus indexPlano={indexPlano}>
				{ item.boleto.bonus ? <ListaConteudosItemListaBonusItem className={ indexPlano === 1 ? 'ultimo' : '' }><strong>+ {item.boleto.bonus} { item.boleto.bonus > 1 ? 'meses' : 'mês' }</strong> de acesso grátis</ListaConteudosItemListaBonusItem> : null }
				{ item.boleto.mentoria ? <ListaConteudosItemListaBonusItem className={ indexPlano === 1 ? 'ultimo' : '' }><strong>+ {item.boleto.mentoria} { item.boleto.mentoria > 1 ? 'meses' : 'mês' }</strong> de Coaching Grátis</ListaConteudosItemListaBonusItem> : null }
				{ item.assinatura_meses ? <ListaConteudosItemListaBonusItem className={ indexPlano === 1 ? 'ultimo' : '' }>Total: <strong className='cor'>{mesesAcesso} { mesesAcesso > 1 ? 'meses' : 'mês' } de acesso</strong></ListaConteudosItemListaBonusItem> : null }
			</ListaConteudosItemListaBonus>

		</ListaConteudosItem>
	}

	return (
		<Container>
			<ContainerInterno>

				{/* Título Principal */}
				<TituloPrincipal>QUANTO MAIOR O PLANO,<br /> <strong>MAIS BÔNUS VOCÊ GANHA</strong></TituloPrincipal>

				{/* Box Baixo */}
				<BoxBaixo>

					{/* Box Imagem */}
					<BoxBaixoCol6 className='boxImagem'>
						<ImagemPrincipal src={bonusCoaching} />
					</BoxBaixoCol6>

					{/* Box Textos */}
					<BoxBaixoCol6>
						
						<ListaConteudos>

							{/* Básica */}
							{ planos.map((plano) => {					
								return plano.assinaturas.map((item, index) => {
									return (
										index === 0 ? itenCard(item) : null
									)
								})
							})}

							{/* Premium */}
							{ planos.map((plano, indexPlano) => {					
								return plano.assinaturas.map((item, index) => {
									return (
										index === 1 ? itenCard(item, true, indexPlano) : null
									)
								})
							})}

						</ListaConteudos>

					</BoxBaixoCol6>

				</BoxBaixo>

				<BoxDataFim>
					<BoxDataFimSpan>OFERTA VÁLIDA SOMENTE ATÉ {date(dataFim)}</BoxDataFimSpan>
				</BoxDataFim>

			</ContainerInterno>
		</Container>
	)
}
